import type { FunctionComponent } from 'react';

import { H2 } from '@/domains/core/tamagoshiv2/components/Typography/Typography';

import styles from './PlaylistTitle.module.scss';

interface Props {
  text?: string;
}

export const PlaylistTitle: FunctionComponent<Props> = ({ text }) => (
  <div className={styles.wrapper}>
    <H2 variant="h3">{text}</H2>
  </div>
);
